import { getEnvVariable } from '@appcharge/shared-ui';
import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: getEnvVariable('REACT_APP_MICROSOFT_CLIENT_ID') || '',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'email', 'profile', 'openid']
};

export const redirectUri = window.location.origin; 